import { useNavigate, useSearchParams } from "react-router-dom";

const useNavigateWithParams = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const navigateWithParams = (path: string, options = {}) => {
    const url = new URL(path, window.location.origin);

    searchParams.forEach((value, key) => {
      url.searchParams.set(key, value);
    });

    navigate(`${url.pathname}${url.search}`, options);
  };

  return navigateWithParams;
};

export default useNavigateWithParams;
